import Modal from "react-modal";
import React from "react";
import * as S from "./styles";
import { useAuth } from "contexts/authContext";

interface ModalProps {
  title: string;
  content: string;
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  buttonText: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

Modal.setAppElement("#root");

export default function ActivationModal({
  title,
  modalIsOpen,
  setIsOpen,
  buttonText,
  onClick,
  content,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }
  const { config } = useAuth();
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveModalContent {...props}>{children}</S.ActiveModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveModalOverlay {...props}>{contentElement}</S.ActiveModalOverlay>
      )}
      className="active-content"
      overlayClassName="active-overlay"
    >
      <S.ModalContent>
        <h2>{title}?</h2>
        <p>{content}</p>
        <S.ActiveButtonContainer>
          <S.ActiveCloseButton onClick={closeModal}>
            Cancelar
          </S.ActiveCloseButton>
          <S.ActiveConfirmButton
            color={config?.color || "#ff8f01"}
            onClick={onClick}
          >
            {buttonText}
          </S.ActiveConfirmButton>
        </S.ActiveButtonContainer>
      </S.ModalContent>
    </Modal>
  );
}
